<template>
  <vx-card>
    <main>
      <div class="w-full mb-base">
        <img
          :src="formData.banner != null ? formData.banner : emptyImage"
          alt="banner-campaign"
          class="rounded-lg mb-2 w-full img-max-height"
        />
        <vs-button color="success" class="ml-2 rounded-2xl">{{
          labelButton
        }}</vs-button>
      </div>
      <div class="w-full mb-base">
        <div class="mb-6">
          <section class="mb-2 flex justify-start">
            <h6><strong>Title</strong></h6>
            <span class="text-danger">*</span>
          </section>
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="title banner"
            v-model="formData.title"
            placeholder="Isi Judul Banner"
          />
          <span class="text-danger text-sm">{{
            errors.first("title banner")
          }}</span>
        </div>
        <div class="mb-6">
          <section class="mb-2 flex justify-start">
            <h6><strong>URL</strong></h6>
            <span class="text-danger">*</span>
          </section>
          <vs-input
            class="w-full"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="url"
            v-model="formData.url"
            placeholder="Isi Link URL Banner"
          />
          <span class="text-danger text-sm">{{
            errors.first("url")
          }}</span>
        </div>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl">Cancel</vs-button>
        <vs-button color="success" class="ml-2 rounded-2xl">{{
          labelButton
        }}</vs-button>
      </div>
    </footer>
  </vx-card>
</template>

<script>
import emptyImage from "@/assets/images/elements/empty.png";

export default {
  props: {
    passData: { type: Object, default: null }
  },
  data() {
    return {
      mitraOption: [
        {
          id: 1,
          text: "Yayasan Anugerah Sejahterah"
        },
        {
          id: 2,
          text: "Yayasan Cinta Sejati"
        },
        {
          id: 3,
          text: "Yayasan Bunga Utara"
        }
      ],
      emptyImage,
      formData: {
        banner: null,
        title: "",
        url : ""
      }
    };
  },
  computed: {
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    currencyValue: {
      get() {
        return Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR"
        }).format(parseFloat(this.formData.targetEarn));
      },
      set(event) {
        this.formData.targetEarn = event;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.img-max-height {
  max-height: 500px;
  overflow: auto;
  object-fit: cover;
}
.quill-height {
  max-height: 600px;
  overflow: auto;
}
</style>
